import React from "react"
import SvgEllipse from "@Components/CustomIcon/SvgEllipseOrange"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { TouchableOpacity, View } from "react-native"
import styles from "./styles"
import { RFValue } from "react-native-responsive-fontsize"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { DiagnosisState, diagnosticStatus } from "@Constants/constant"
import { baseColors } from "@Constants/baseStyles"

const CardWithoutProgression = (props) => {
    const {
        title,
        onPress,
        bgColor,
        ellipseColor,
        svgIcon,
        withStatus,
        currentDiagnoseStatus,
        disabled,
        unPlannifiedStatus
    } = props
    const founded = diagnosticStatus.filter((item) => item.status === currentDiagnoseStatus?.code)
    const descripiton = founded && founded.length > 0 ? founded[0].descripiton : diagnosticStatus[0].descripiton
    const containerStyle =
        withStatus || unPlannifiedStatus ? { ...styles.cardContainer, backgroundColor: bgColor } : undefined
    const statusLabelStyle =
        currentDiagnoseStatus?.code === DiagnosisState.READY
            ? { ...styles.statusLabel, color: baseColors.orange.dark }
            : { ...styles.statusLabel }

    return (
        <TouchableOpacity style={containerStyle} activeOpacity={0.7} onPress={onPress} disabled={disabled}>
            {disabled && (
                <View
                    style={{
                        backgroundColor: "rgba(0,0,0,0.3)",
                        position: "absolute",
                        height: "100%",
                        borderRadius: 10,
                        width: "100%",
                        zIndex: 2
                    }}
                ></View>
            )}
            <View
                style={{
                    ...styles.card,
                    backgroundColor: bgColor
                }}
            >
                <View style={{ flexDirection: "column", justifyContent: "center", flex: 1 }}>
                    <BreeSerifText fontSize={RFValue(20)} style={styles.title} color={"white"}>
                        {title}
                    </BreeSerifText>

                    {withStatus && (
                        <View style={styles.statusLabelContainer}>
                            <OpenSansText style={statusLabelStyle}>{currentDiagnoseStatus?.name}</OpenSansText>
                        </View>
                    )}
                </View>

                <View style={{ position: "absolute", alignSelf: "flex-end" }}>
                    <SvgEllipse height={100} width={100} fill={ellipseColor} />
                    {svgIcon}
                </View>
            </View>

            {withStatus && (
                <View style={{ paddingHorizontal: 15, paddingVertical: 15 }}>
                    <OpenSansText
                        style={{
                            color: "white"
                        }}
                    >
                        {descripiton}
                    </OpenSansText>
                </View>
            )}
        </TouchableOpacity>
    )
}

export default CardWithoutProgression
